"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _BirdsBackground = require("../BirdsBackground");

var styles = {
  root: {
    backgroundColor: function backgroundColor(_ref) {
      var palette = _ref.palette;
      return palette.common.white;
    },
    minHeight: '100vh',
    position: 'relative',
    overflow: 'hidden'
  },
  birdsBackground: {
    transform: 'translate(25%, 0)'
  },
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: function backgroundColor(_ref2) {
      var palette = _ref2.palette;
      return palette.common.white;
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

var EditContainer = function EditContainer(_ref3) {
  var children = _ref3.children,
      _ref3$loading = _ref3.loading,
      loading = _ref3$loading === void 0 ? false : _ref3$loading;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Fade, {
    in: loading,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.loader
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.root
  }, /*#__PURE__*/_react.default.createElement(_BirdsBackground.BirdsBackground, {
    sx: styles.birdsBackground
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    position: "relative"
  }, children)));
};

var _default = EditContainer;
exports.default = _default;